export default {
  gold: require('./gold.png'),
  silver: require('./silver.png'),
  bronze: require('./bronze.png'),
}
